module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0018.jpg?v=3318c65d";